export const OFFER_SEARCH_FORM_NAME = 'offersSearch';
export const OFFER_SEARCH_FIELD = 'searchString';
export const SELECTABLE_TAB_CSS_NAME = 'selectableTab';
export const MAIN_DROPDOWN_NAME = 'greyTabs';

//DROPDOWN FIELD NAMES
export const offerDropdownFields = Object.freeze({
  vertical: 'Vertical',
  payoutType: 'Payout',
  targeting: 'Targeting',
  acceptedCountry: 'Country',
  niche: 'Niche',
  status: 'approval_status',
  acceptedPromotionMethod: 'MediaPlacement',
  performsIn: 'TopCountries',
  id: 'Id',
});

export const offerMobileDropdownStateFields = Object.freeze({
  mainDropdownActive: 'mainDropdownActive',
  subDropdown: 'subDropdown',
});

//DROPDOWN LABELS
export const offerDropdownLabels = Object.freeze({
  [offerDropdownFields.vertical]: 'Vertical',
  [offerDropdownFields.payoutType]: 'Payout Type',
  [offerDropdownFields.targeting]: 'Targeting',
  [offerDropdownFields.acceptedCountry]: 'Accepted Country',
  [offerDropdownFields.niche]: 'Niche',
  [offerDropdownFields.status]: 'Status',
  [offerDropdownFields.acceptedPromotionMethod]: 'Accepted Promotion Method',
  [offerDropdownFields.performsIn]: 'Performs In',
});

//DROPDOWN CUSTOM LABELS INSIDE THE DROPDOWN
export const offerDropdownCustomLabels = Object.freeze({
  [offerDropdownFields.acceptedPromotionMethod]: 'Promo Method',
});

//DROPDOWNS THAT INCLUDE SEARCH
export const offerDropdownIncludesSearch = [
  offerDropdownFields.payoutType,
  offerDropdownFields.acceptedCountry,
  offerDropdownFields.performsIn,
];

//GREEN MOBILE CTA TYPES
export const largeCtaTypes = Object.freeze({
  mainFilter: 'mainFilter',
  mobileMenuBottom: 'mobileMenuBottom',
});

export let statusDropdown = ['Approved', 'Pending', 'Rejected', 'Approval Required'];
statusDropdown = statusDropdown.map((text) => ({ name: text }));

export const filterNiche = (categoriesList) =>
  categoriesList
    .filter((category) => category.name.includes('Niche'))
    .map((category) => ({ ...category, name: category.name.split('Niche - ')[1] }));
